const dataBaseReducer = (state = {}, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default dataBaseReducer;
